<script lang="ts">
  import { richTextFormatter } from '$lib/helpers/richTextHelper';
  import type { AuthorPanel } from '$lib/types/articleTypes';

  export let authorPanel: AuthorPanel;
  $: elementProps = authorPanel?.trainerHref ? { href: authorPanel?.trainerHref } : {};
</script>

{#if authorPanel?.name != undefined}
  <section class="flex flex-row gap-3 lg:gap-4">
    <svelte:element this={elementProps?.href ? 'a' : 'div'} {...elementProps}>
      <div class="w-12 h-12 lg:w-14 lg:h-14">
        <img
          src="{authorPanel?.image?.url}?w=300&q=85&fm=webp"
          alt={authorPanel?.image?.title}
          class="rounded-full border-[0.75px] w-full h-full"
        />
      </div>
    </svelte:element>
    <div class="max-w-[40.5rem]">
      <svelte:element
        this={elementProps?.href ? 'a' : 'p'}
        class="text-gray-900 font-semibold text-md lg:text-lg {authorPanel?.trainerHref
          ? 'underline hover:text-gray-700'
          : ''}"
        {...elementProps}
      >
        {authorPanel?.name}
      </svelte:element>
      <slot name="description">
        <p>{@html richTextFormatter(authorPanel?.bio)}</p>
      </slot>
    </div>
  </section>
{/if}
